// React
import { Link } from "react-router-dom";

// Material UI
import { Typography } from "@mui/material";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

const Cancel = () => {
    return(
        <Container>
            <Box 
                m="auto"
                sx={{ 
                    marginTop: '100px',
                    width: '800px',
                }}
            >    
                <Typography variant="h4">
                    Transaction Cancelled
                </Typography>
                <br />
                <Typography 
                    variant="body1"
                    sx={{
                        marginLeft: '40px', 
                        marginRight: '40px'
                    }}
                >
                    We couldn't process your donation. Please try a different method of payment or try again later.
                </Typography>
                <br />
                <Link to="/" style={{ textDecoration: 'none' }}>
                    <Button variant="outlined" color="primary">
                        Try again
                    </Button>
                </Link>
            </Box>
        </Container>
    )
}

export default Cancel;
